import {
  TranslationPermissionMessages,
  PermissionMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationPermissionMessages = {
  [PermissionMessages.linkContractToUserText]: "Vincular contrato ao usuário",
  [PermissionMessages.linkContractsSelectedText]:
    "Vincular contratos selecionados",
  [PermissionMessages.permissionsForText]: "Permissões para",
  [PermissionMessages.searchContractOrConstructionText]: "Ou busque pelo contrato ou pela obra"
};
